import axios from "axios";
import { apiBaseUrl } from "../../../helpers/UrlHelper";
import { handleError } from "../../../helpers/ErrorHelper";
import { debounce } from "../../../helpers/Debounce";

function _success(success) {
  return { type: "GET_SERVER_MODULES_SUCCESS", success };
}

function _error(error) {
  return { type: "GET_SERVER_MODULES_ERROR", error };
}

function _processing(processing) {
  return { type: "GET_SERVER_MODULES_PROCESSING", processing };
}

function getServerModules(paginate = true, shouldDebounce = false) {
  return (dispatch, getState) => {
    dispatch(_processing(true));
    dispatch(_error(null));

    let { serverModuleList } = getState();
    let { params } = serverModuleList.data;

    const url = paginate ? `admin/servers` : `admin/servers?paginate=0`;
    const request = () =>
      axios({
        url: apiBaseUrl(url),
        method: "get",
        dataType: "json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem(`Bearer`),
        },
        ...(paginate && { params }),
      })
        .then(function (res) {
          dispatch(_processing(false));
          dispatch(_success(res));
        })
        .catch(function (error) {
          handleError(error);
          dispatch(_error(error));
          dispatch(_processing(false));
        });

    debounce.makeRequest(request, shouldDebounce);
  };
}

export default getServerModules;
